import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import {
  SearchCustomer,
  ExistingClient,
  OtpForm,
  CreateCustomer,
  LeadCreate,
  CustomerDetails,
  WorkExperience,
  Documents,
  LeadHeader,
  CreateCompany,
} from "./components";
import { State } from "../../core/store/interfaces";
import { Customer, Phone, EmailAddress } from "../../core/api/models";
import Accordion from "../../components/Accordion";
import "../../styles/details.scss";
import api from "../../api";
import {
  DateFormats,
  formatDate,
  useLead,
  Lead,
  useHasPermission,
  capitalizeFirstLetter,
  StageTransition,
  getInvalidCustomerFieldsEnquiry,
  LeadQuality,
  ContactType,
  Company,
  useConfiguration,
} from "../../core";
import { ContainerLoader } from "../../components/loader";
import LinkedLeads from "./components/linked-leads/LinkedLeads";
import AssignUsers from "./components/assign-users/AssignUsers";
import Actions from "./components/actions/Actions";
import {
  ValidateEmail,
  ValidatePhoneNumberRegEx,
  ValidateNumber,
} from "../../utils/Validatation";
import LeadEdit from "./components/LeadEdit";
import { LeadActivities } from "./components/activities/lead-activities";
import { useLeadCalendarContext } from "../../core/hooks/useLeadCalendarContext";
import { EditEventCalendarWraper } from "../../core/components/calendar/edit-event-calendar-wraper";
import { ActivityModel } from "./components/activities/add-activity";
import { RouteKeys } from "../routes/route-keys";
import { AppPermissions } from "../../core/api/models/permissions";
import { ConfirmationDialogProvider } from "../../core/components/confirm-popup/confirm-popup";
import InvalidFieldsForEnquiryBanner from "./components/InvalidFieldsForEnquiryBanner";
import { useMasterData } from "../../core/hooks/useMasterData";
import CustomerEdit from "../customer/components/customer-stage-edit/CustomerEdit";
import RadioSelect from "../../components/radio-select";
import { getStringAsEnumValue } from "../../utils/util-functions";
import { StatusCodes } from "http-status-codes";
import SearchAndAssignCompanyUser from "./components/company-customer/SearchAndAssignUser";
import SearchCompany from "./components/SearchCompany";
import CompanyDetails from "./components/CompanyDetails";
import CustomeList from "./components/company/CustomeList";
import InterestedProjects from "./components/interested-project/InterestedProject";
import RequirementList from "./components/requirements/RequirementList";
import Requirement from "../requirement";

const AddLeadForm: React.FunctionComponent<{
  onClose?: (customerId?: string) => void;
  id?: string;
  leadCreated?: () => void;
  customerId?: string;
  addOnly?: boolean;
  leads?: Lead[];
  phones?: Phone[];
  emails?: EmailAddress[];
  stage?: string;
  hideConfig?: boolean;
  showReaderButton?: boolean;
  disablePrevArrow?: boolean;
  disableNextArrow?: boolean;
  prevSlide?: () => void;
  nextSlide?: () => void;
  showNextPrev?: boolean;
  companyId?: string;
}> = (props) => {
  const masterData = useMasterData(api.settings);
  const { modalOpen: requirementModalOpen } = useConfiguration(api);

  const history = useHistory();
  const {
    getLead,
    updateCustomerDetails,
    clearData,
    fetching,
    updateCompanyDetails,
  } = useLead(api.lead);
  const {
    showCalendar,
    selectedDate,
    setSelectedDate,
    selectedAssignee,
    setInitialData,
    relaodTrigger,
  } = useLeadCalendarContext();
  const canCreateCustomer = useHasPermission(AppPermissions.CreateCustomer);
  const canViewCustomerDetails = useHasPermission(
    AppPermissions.ViewCustomerDetails
  );
  const canAssignCRMAgent = useHasPermission(AppPermissions.AssignCRMAgent);
  const canUpdateCrmAgent = useHasPermission(AppPermissions.CanUpdateCrmAgent);
  const canAssignSalesPerson = useHasPermission(
    AppPermissions.AssignSalesPerson
  );
  const canUpdateSalesPerson = useHasPermission(
    AppPermissions.CanUpdateSalesPerson
  );
  const canViewLeadActivities = useHasPermission(
    AppPermissions.ViewLeadActivities
  );
  const [contactType, setContactType] = React.useState<ContactType>(
    props?.customerId ? ContactType.Customer : ContactType.Company
  );
  const [hasContact, setHasContact] = React.useState<boolean>(false);
  const canViewActivityList = useHasPermission(AppPermissions.ViewActivityList);
  const canSetLeadQuality = useHasPermission(AppPermissions.SetLeadQuality);
  const canMapTags = useHasPermission(AppPermissions.MapTags);
  const canScheduleTestDrive = useHasPermission(
    AppPermissions.ScheduleTestDrive
  );
  const canRequestCallBack = useHasPermission(AppPermissions.RequestCallBack);
  const canAddVehicleToLead = useHasPermission(AppPermissions.AddVehicleToLead);
  const canScheduleShowroomVisit = useHasPermission(
    AppPermissions.ScheduleShowroomVisit
  );
  const canConvertToEnquiry = useHasPermission(AppPermissions.ConvertToEnquiry);
  const canCreateLeadActivity = useHasPermission(
    AppPermissions.CreateLeadActivity
  );
  const leadState = useSelector((state: State) => state.lead);

  const [customerDetails, setCustomerDetails] = useState<Customer>();
  const [contactUserDetails, setContactUserDetails] = useState<Customer>();
  const [selectedContactUserIds, setSelectedContactUserIds] = useState<
    string[]
  >([]);
  const dataToPass = leadState?.leadDetails?.company;
  const [resetState, setResetState] = useState(dataToPass);
  const [phones, setPhones] = useState<Phone[] | undefined>(props.phones);
  const [emails, setEmails] = useState<EmailAddress[] | undefined>(
    props.emails
  );
  const [civilId, setCivilId] = useState("");
  const [seachValue, setSearchValue] = useState<string>();
  const [stage, setStage] = useState<string>(
    props.id ? "lead-edits" : props.stage || "fetch-customer"
  );
  const [searchPhone, setSearchPhone] = useState<string>();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isCustomerLoaded, setCustomerLoaded] = useState<boolean>(false);
  const [isFromExistingList, setFromExistingList] = useState<boolean>(false);
  const [companyDetails, setCompanyDetails] = useState<Company>();
  const [designationId, setDesignationId] = useState<string|null>(null);
  const [customerModal, setCustomerModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
    entity?: string;
  }>({});
  const [_, setShowLeadTitleEdit] = useState<boolean>(false);

  React.useEffect(() => {
    if (props.id && !fetching) {
      setIsLoaded(true);
      getLead(props.id);
    } else {
      if (!isLoaded) {
        clearData();
      }
      setIsLoaded(true);
    }
  }, [props.id]);

  React.useEffect(() => {
    if (props.id && !isLoaded) {
      setIsLoaded(true);
      getLead(props.id);
    } else {
      if (!isLoaded) {
        clearData();
      }
      setIsLoaded(true);
    }

    if (props.customerId && !isCustomerLoaded) {
      setCustomerLoaded(true);
      getCustomerDetails();
    } else {
      setCustomerLoaded(true);
    }

    if (props.companyId && !isCustomerLoaded) {
      setCustomerLoaded(true);
      getCompanyDetails();
    } else {
      setCustomerLoaded(true);
    }
  });

  const getCustomerDetails = async () => {
    setStage(props.id ? "lead-edits" : "lead-details");

    const res = await api.customer.getDetails(props.customerId || "");
    setCustomerDetails(res);
    if (res?.isCompanyCustomer) {
      setContactType(ContactType.Company);
    }
  };

  const getCompanyDetails = async () => {
    setStage(props.id ? "lead-edits" : "lead-details");
    const res = await api.company.getDetails(props.companyId || "");
    setCompanyDetails(res);

    setContactType(ContactType.Company);
  };

  const onLeadClick = (id: string) => {
    getLead(id);
    setStage("lead-edits");
    setFromExistingList(true);
  };

  const getComapnyCustomerDetails = async (customerId: string) => {
    const res = await api.customer.getDetails(customerId || "");
    setCustomerDetails(res);
  };

  React.useEffect(() => {
    if (!!selectedContactUserIds?.length) {
      getComapnyCustomerDetails(selectedContactUserIds?.[0]!);
    } else {
      setCustomerDetails(undefined);
    }
  }, [selectedContactUserIds]);

  const manageContactSelectionInPopUp = (userId: string, userType?: string) => {
    if (selectedContactUserIds?.find((id) => id === userId)) {
      setSelectedContactUserIds(
        selectedContactUserIds?.filter((id) => id !== userId)
      );
    } else if (userType && userType === "singleUser") {
      setSelectedContactUserIds([userId]);
    } else {
      setSelectedContactUserIds([...selectedContactUserIds, userId]);
    }
  };

  const verifyOtp = async (otp: string) => {
    try {
      const response = await api.customer.unlinkPhoneVerify(
        { phone: searchPhone || "", otp },
        customerDetails?._id
      );

      setPhones([response.data]);
      setStage("create-customer");
    } catch (error) {
      toastr.error("Error", error?.response?.data?.message);
    }
  };
  const isCompanyCustomer =
    contactType === ContactType.Company || customerDetails?.isCompanyCustomer;

  const onFetchDetails = (
    data: Customer,
    query: string,
    searchType?: string
  ) => {
    setDesignationId(null);
    setCustomerDetails(data);
    setPhones(undefined);
    setEmails(undefined);
    setCivilId("");

    setSearchPhone("");

    if (searchType === "mobile" && !data && ValidateNumber(query)) {
      setPhones([
        { phone: query, phoneType: "Mobile", isPrimary: true },
      ]);
    }
    if (searchType === "email" && !data && ValidateEmail(query)) {
      setEmails([{ email: query, emailType: "Business", isPrimary: true }]);
    }
    if (searchType === "civilId") {
      setCivilId(query);
    }
    if (data) {
      setPhones(data?.phones);
    }

    if (data && ValidatePhoneNumberRegEx(query) && searchType === "mobile") {
      setSearchPhone(query);
    }
    if (isCompanyCustomer) {
      setStage(
        data || !canCreateCustomer ? "existing-customer" : "create-user"
      );
    } else {
      setStage(
        data || !canCreateCustomer ? "existing-customer" : "create-customer"
      );
    }
  };

  const onFetchContactDetails = (
    data: Customer,
    query: string,
    searchType?: string
  ) => {
    setDesignationId(null);
    setContactUserDetails(data);
    setPhones(undefined);
    setEmails(undefined);
    setCivilId("");

    setSearchPhone("");

    if (searchType === "mobile" && !data && ValidateNumber(query)) {
      setPhones([
        { phone: query, phoneType: "Mobile", isPrimary: true },
      ]);
    }
    if (searchType === "email" && !data && ValidateEmail(query)) {
      setEmails([{ email: query, emailType: "Business", isPrimary: true }]);
    }

    if (data) {
      setPhones(data?.phones);
    }

    if (data && ValidatePhoneNumberRegEx(query) && searchType === "mobile") {
      setSearchPhone(query);
    }

    if (isCompanyCustomer) {
      setStage(data || !canCreateCustomer ? "existing-contact" : "create-user");
    } else {
      setStage(
        data || !canCreateCustomer ? "existing-customer" : "create-customer"
      );
    }
  };

  const createContactLessCustomer = (val:string) => {
    setDesignationId(val);
    setStage("create-user");
  };

  const onCreateCustomer = (data: Customer) => {
    setCustomerDetails(data);
    setStage("lead-details");
    setPhones([]);
    setEmails([]);
  };

  const onCreateCompany = (data: Company) => {
    setCompanyDetails(data);
    setStage("add-user");
  };

  const loadCompany = async (companyId: string) => {
    const res = await api.company.getDetails(companyId);
    setCompanyDetails(res);
  };

  const onCancelAndStateRefresh = () => {
    if (props.id) {
      getLead(props.id);
    }
    if (companyDetails?._id) {
      loadCompany(companyDetails?._id);
    }
  };

  const updateCompany = (data: Company) => {
    if (leadState.leadDetails) {
      updateCompanyDetails(data);
    }
    setCompanyDetails(data);
    props.leadCreated?.();
  };

  const onAddContactUser = (data: Customer) => {
    setContactUserDetails(data);
    setStage("lead-details");
  };

  const onAddExistingContactUser = async (data: Customer) => {
    setContactUserDetails(data);

    try {
      const response = await api.customer.addExistingCustomerAsCompanyContact({
        customerId: data._id!,
        companyId: companyDetails?._id!,
      });
      if (response.status === StatusCodes.OK) {
        setStage("lead-details");
      } else {
        toastr.error(
          "Error",
          response?.message || "Error while adding contact"
        );
      }
    } catch (err) {
      toastr.error("Error", "Error while adding contact");
    }
  };
  const updateUser = (data: Customer) => {
    if (leadState.leadDetails) {
      updateCustomerDetails(data);
    }
    setCustomerDetails(data);
    props.leadCreated?.();
  };

  const leadCreated = (id?: string) => {
    if (props.id) {
      props.leadCreated?.();
    } else if (props.addOnly) {
      props.onClose?.(
        leadState?.leadDetails?.company?._id ||
          leadState?.leadDetails?.customer?._id ||
          companyDetails?._id ||
          customerDetails?._id
      );
    } else {
      history.push(`${RouteKeys.Leads}/${id || ""}`);
    }
  };

  const onUpdate = () => {
    props.leadCreated?.();
  };

  const calculateDateDifference = (d1: Date, d2: Date) => {
    const date1 = moment(d1).startOf("day");
    const date2 = moment(d2).startOf("day");
    return date2.diff(date1, "days");
  };

  const canShowActions =
    (!leadState.leadDetails?.isDeal && canSetLeadQuality) ||
    canMapTags ||
    canScheduleTestDrive ||
    canRequestCallBack ||
    canAddVehicleToLead ||
    canScheduleShowroomVisit ||
    (!leadState.leadDetails?.isDeal && canConvertToEnquiry) ||
    canCreateLeadActivity;

  const invalidCustomerFieldsForEnquiry =
    !leadState?.leadDetails?.isDeal && leadState.leadDetails?.customer
      ? getInvalidCustomerFieldsEnquiry(
          leadState.leadDetails?.customer,
          masterData?.data?.leadStages
            ?.find((x) => x.code === "enquiry")
            ?.entity?.find((c) => c.key === "Customer")!
        )
      : [];

  return (
    <ConfirmationDialogProvider>
      <div className="detail-poupup bg-white position-fixed top-0 w-100 h-100 overflow-auto in">
        <LeadHeader
          onClose={() => {
            if (!isFromExistingList) {
              props.onClose?.(
                leadState?.leadDetails?.company?._id ||
                  companyDetails?._id ||
                  leadState?.leadDetails?.customer?._id ||
                  customerDetails?._id
              );
            } else {
              setStage("existing-customer");
              setFromExistingList(false);
            }
            clearData();
          }}
          prevSlide={props.prevSlide}
          nextSlide={props.nextSlide}
          disablePrevArrow={props.disablePrevArrow}
          disableNextArrow={props.disableNextArrow}
          fetching={fetching}
          showNextPrev={props.showNextPrev}
          onReload={() => {
            getLead(leadState?.leadDetails?._id!);
          }}
        ></LeadHeader>
        {leadState.leadDetails?.isDeal && (
          <div className="d-flex dealSections border-bottom font-xs font-weight-semibold text-gray-400 text-center">
            {leadState?.leadDetails?.stagesTransitions
              ?.sort(
                (a: StageTransition, b: StageTransition) =>
                  a.position - b.position
              )
              ?.map((stages) => {
                return (
                  <div
                    className={`col py-1 px-1 dealSections__item ${
                      stages.startedOn ? "text-gray-900" : ""
                    } `}
                  >
                    {capitalizeFirstLetter(stages.name)}{" "}
                    {stages.startedOn
                      ? `(${calculateDateDifference(
                          new Date(stages.startedOn),
                          new Date()
                        )} days)`
                      : ""}
                  </div>
                );
              })}
          </div>
        )}
        {!leadState.leadDetails?.isDeal &&
          (leadState.leadDetails?.quality === LeadQuality.Interested ||
            leadState.leadDetails?.quality === LeadQuality.NotIntrested) && (
            <InvalidFieldsForEnquiryBanner
              invalidITems={invalidCustomerFieldsForEnquiry}
              onAction={() =>
                setCustomerModal({
                  isOpen: true,
                  id: leadState?.leadDetails?.customer?._id,
                  entity: "enquiry",
                })
              }
            ></InvalidFieldsForEnquiryBanner>
          )}

        <div className="container-fluid px-0 h-100">
          {isLoaded ? (
            <div className="row no-gutters h-100">
              <div
                className={
                  stage === "create-customer" || stage === "create-company"
                    ? "col-12"
                    : "col-md-4 col-12 border-right"
                }
              >
                {(stage === "fetch-customer" ||
                  stage === "otp" ||
                  stage === "create-customer") && (
                  <div className="d-flex border-bottom align-items-center py-3 px-4">
                    <h6 className="mb-0"> Contact Details</h6>
                  </div>
                )}

                {stage === "fetch-customer" && (
                  <div className="">
                    <div className="px-4 pt-4">
                      <div className="form-group font-weight-semibold mb-0">
                        <RadioSelect
                          defaultValue={contactType}
                          type="string"
                          options={[
                            { label: "Company", value: ContactType.Company },
                            { label: "Person", value: ContactType.Customer },
                          ]}
                          optionLabel={"label"}
                          optionValue={"value"}
                          onChange={(val) =>
                            setContactType(
                              getStringAsEnumValue(
                                ContactType,
                                typeof val === "string" ? val : "",
                                ContactType.Company
                              )
                            )
                          }
                          paddingClass="pr-0"
                        />
                      </div>
                    </div>
                    {contactType === ContactType.Customer && (
                      <SearchCustomer
                        onFetchDetails={(
                          details: Customer,
                          query: string,
                          searchType: string
                        ) => onFetchDetails(details, query, searchType)}
                        setStage={(stageName: string) => setStage(stageName)}
                      ></SearchCustomer>
                    )}
                    {contactType === ContactType.Company && (
                      <SearchCompany
                        onFetchDetails={(
                          details: Customer,
                          query: string,
                          searchType: string
                        ) => onFetchDetails(details, query, searchType)}
                        setStage={(stageName: string) => setStage(stageName)}
                        wraperClassName={"col-md-3"}
                        onSelect={(company?: Company, customer?: Customer) => {
                          if(customer?._id){
                            setSelectedContactUserIds([customer?._id || ''])
                          }
                          setCompanyDetails(company);
                        }}
                        setSearchValue={setSearchValue}
                      ></SearchCompany>
                    )}
                  </div>
                )}
                {(stage === "create-customer" ||
                  stage === "create-company") && (
                  <>
                    {!isCompanyCustomer ? (
                      <CreateCustomer
                        customerDetails={customerDetails}
                        onCreateCustomer={(details: Customer) =>
                          onCreateCustomer(details)
                        }
                        setStage={(stageName: string) => setStage(stageName)}
                        phones={phones}
                        emails={emails}
                        gridColumns={3}
                      ></CreateCustomer>
                    ) : (
                      <CreateCompany
                        onCreateCompany={(details: Company) =>
                          onCreateCompany(details)
                        }
                        setStage={(stageName: string) => setStage(stageName)}
                        phones={phones}
                        searchQuery={seachValue}
                        emails={emails}
                        civilId={civilId}
                      ></CreateCompany>
                    )}
                  </>
                )}
                {isCompanyCustomer && (
                  <>
                    {(stage === "lead-details" ||
                      stage === "lead-edits" ||
                      stage === "add-user" ||
                      stage === "existing-contact" ||
                      stage === "create-user" ||
                      stage === "company-user-details") && (
                      <>
                        <CompanyDetails
                          details={
                            stage === "lead-edits"
                              ? resetState || leadState?.leadDetails?.company
                              : companyDetails
                          }
                          setStage={(stageName: string) => setStage(stageName)}
                          updateCompany={(details: Customer) =>
                            updateCompany(details)
                          }
                          stage={stage}
                          onStateChange={() => onCancelAndStateRefresh()}
                          showDetailsLink
                        ></CompanyDetails>
                        {leadState?.leadDetails && (
                          <CustomeList
                            leadId={leadState?.leadDetails?._id}
                            companyId={leadState?.leadDetails?.company?._id}
                            updateUser={(details: Customer) =>
                              updateCustomerDetails(details)
                            }
                          ></CustomeList>
                        )}
                      </>
                    )}
                  </>
                )}
                {!isCompanyCustomer && (
                  <>
                    {(stage === "lead-details" ||
                      stage === "lead-edits" ||
                      stage === "add-user" ||
                      stage === "create-user" ||
                      stage === "company-user-details") && (
                      <>
                        <CustomerDetails
                          customerDetails={
                            stage === "lead-edits"
                              ? leadState?.leadDetails?.customer
                              : customerDetails
                          }
                          setStage={(stageName: string) => setStage(stageName)}
                          updateUser={(details: Customer) =>
                            updateUser(details)
                          }
                          show360Link
                        ></CustomerDetails>
                      </>
                    )}
                  </>
                )}

                {leadState?.leadDetails && (
                  <InterestedProjects
                    onUpdate={() => {
                      getLead(leadState?.leadDetails?._id!);
                    }}
                    onUpdateConfiguration={() => {
                      getLead(leadState?.leadDetails?._id!);
                    }}
                  ></InterestedProjects>
                )}
                {!!leadState?.leadDetails?.requirements?.length && (
                  <RequirementList
                    onReload={() => {
                      getLead(leadState?.leadDetails?._id!);
                    }}
                  ></RequirementList>
                )}
                {leadState?.leadDetails?._id && (
                  <LinkedLeads id={leadState?.leadDetails?._id}></LinkedLeads>
                )}
                {stage === "existing-customer" && (
                  <>
                    <ExistingClient
                      customerDetails={customerDetails}
                      setStage={(stageName: string) => setStage(stageName)}
                      phone={searchPhone}
                      onLeadClick={onLeadClick}
                      onClose={()=>setStage("fetch-customer")}
                      civilId={civilId}
                    ></ExistingClient>
                  </>
                )}
                {stage === "otp" && (
                  <OtpForm
                    verifyOtp={(otp: string) => verifyOtp(otp)}
                    setStage={(stageName: string) => setStage(stageName)}
                    phone={searchPhone}
                    customerDetails={customerDetails}
                  ></OtpForm>
                )}
              </div>
              {(stage === "add-user" ||
                stage === "existing-contact" ||
                stage === "create-user") &&
                isCompanyCustomer && (
                  <>
                    <div className={`${stage === "add-user" ? "col-md-5" : "col-md "} col-12 border-right`}>
                      <div className="d-flex border-bottom align-items-center py-3 px-4">
                        <h6 className="mb-0">Add Contact</h6>
                      </div>

                      {stage === "add-user" && (
                        <div className="">
                          <SearchCustomer
                            onFetchDetails={(
                              details: Customer,
                              query: string,
                              searchType: string
                            ) =>
                              onFetchContactDetails(details, query, searchType)
                            }
                            handleContactlessCustomer={createContactLessCustomer}
                            setStage={(stageName: string) =>
                              setStage(stageName)
                            }
                            onCancel={() => setStage("lead-details")}
                            hasContact
                          ></SearchCustomer>
                          <div className="text-center position-relative">
                            <span className="bg-white font-xs text-gray-500 position-relative px-1"></span>
                          </div>
                        </div>
                      )}
                      {stage === "existing-contact" && (
                        <>
                          <ExistingClient
                            customerDetails={contactUserDetails}
                            setStage={(stageName: string) =>
                              setStage(stageName)
                            }
                            phone={searchPhone}
                            onLeadClick={onLeadClick}
                            civilId={civilId}
                            addExistingCustomerAsUser={(details: Customer) => {
                              onAddExistingContactUser(details);
                              manageContactSelectionInPopUp(details?._id!);
                            }}
                            isCompanyLead={true}
                          ></ExistingClient>
                        </>
                      )}
                      {stage === "create-user" && (
                        <CreateCustomer
                          designationId={designationId}
                          isContactlessCustomer={!!designationId}
                          customerDetails={customerDetails}
                          onCreateCustomer={(details: Customer) =>
                            onAddContactUser(details)
                          }
                          setStage={(stageName: string) => setStage(stageName)}
                          phones={phones}
                          emails={emails}
                          isContact
                          parentCompanyCustomer={customerDetails}
                          onCloseStageName="add-user"
                          isCompanyCustomer
                          companyId={companyDetails?._id}

                        ></CreateCustomer>
                      )}
                    </div>
                    <div className="col-md-4 col-12"></div>
                  </>
                )}

              {(stage === "lead-details" || stage === "company-user-details") &&
                isCompanyCustomer &&
                companyDetails && (
                  <div className="col-md-4 col-12 border-right ">
                    <SearchAndAssignCompanyUser
                      setStage={(stageName: string) => setStage(stageName)}
                      wraperClassName={"col-md-3"}
                      onSelect={(userId?: string) => {
                        if (userId) {
                          manageContactSelectionInPopUp(userId, "singleUser");
                        }
                      }}
                      companyId={companyDetails?._id}
                      customerDetails={customerDetails!}
                      setHasContact={setHasContact}
                      selectedContactIds={selectedContactUserIds}
                    ></SearchAndAssignCompanyUser>
                  </div>
                )}
              {stage === "lead-details" &&
              (!isCompanyCustomer ||
                (hasContact && selectedContactUserIds?.length)) ? (
                <LeadCreate
                  customerDetails={customerDetails}
                  setStage={(stageName: string) => setStage(stageName)}
                  leadCreated={leadCreated}
                  contactIds={selectedContactUserIds}
                  companyDetails={companyDetails}
                ></LeadCreate>
              ) : (
                <></>
              )}

              {stage === "lead-edits" && fetching && (
                <div className="col-md col-12 border-right accordion">
                  <ContainerLoader height={100}></ContainerLoader>
                </div>
              )}

              {stage === "lead-edits" && leadState?.leadDetails && (
                <>
                  <div className="col-md col-12 border-right accordion">
                    <Accordion defaultId="Assigned User">
                      {canShowActions &&
                        leadState?.leadDetails?.isEditable &&
                        !leadState.leadDetails?.customer?.isBlocked && (
                          <div id="Activities">
                            <Actions
                              lead={leadState}
                              onUpdate={onUpdate}
                              leads={props.leads}
                              disableConvertEnquiry={
                                !!invalidCustomerFieldsForEnquiry?.length
                              }
                            ></Actions>
                          </div>
                        )}
                      {((canAssignSalesPerson &&
                        !leadState.leadDetails?.currentSalesPerson) ||
                        (canUpdateSalesPerson &&
                          !!leadState.leadDetails?.currentSalesPerson) ||
                        (canAssignCRMAgent &&
                          !leadState.leadDetails?.currentCRMAgent) ||
                        (canUpdateCrmAgent &&
                          !!leadState.leadDetails?.currentCRMAgent)) &&
                        leadState?.leadDetails?.isEditable && (
                          <div id="Assigned User">
                            <AssignUsers onUpdate={onUpdate}></AssignUsers>
                          </div>
                        )}
                      {canViewCustomerDetails &&
                        !leadState?.leadDetails?.company && (
                          <div id="Work Experience">
                            <WorkExperience
                              updateUser={(details: Customer) =>
                                updateUser(details)
                              }
                            ></WorkExperience>
                          </div>
                        )}
                      {leadState?.leadDetails &&
                        canViewCustomerDetails &&
                        !leadState?.leadDetails?.company && (
                          <div id="Documents">
                            <Documents
                              customerDetails={
                                stage === "lead-edits"
                                  ? leadState?.leadDetails?.customer
                                  : customerDetails
                              }
                            ></Documents>
                          </div>
                        )}
                      {leadState?.leadDetails && (
                        <div id="Lead Settings">
                          <LeadEdit
                            onUpdate={onUpdate}
                            leadDetails={leadState?.leadDetails}
                          ></LeadEdit>
                        </div>
                      )}
                    </Accordion>
                  </div>
                  {canViewLeadActivities || canViewActivityList ? (
                    <>
                      {!showCalendar && (
                        <LeadActivities
                          id={leadState?.leadDetails?._id!}
                          onReload={() => getLead(leadState?.leadDetails?._id!)}
                        ></LeadActivities>
                      )}
                      {showCalendar && (
                        <div className="col-md-4 col-12">
                          <div className="position-sticky top-detail-head-height">
                            <EditEventCalendarWraper
                              resourceId={selectedAssignee}
                              selectedDate={selectedDate!}
                              onDateChange={(date: Date) => {
                                setSelectedDate(date);
                              }}
                              reloadTrigger={relaodTrigger}
                              onSelectSlot={(start: Date, end: Date) => {
                                const activityModel: ActivityModel = {
                                  timePeriod: {
                                    startDate: moment(start)
                                      .endOf("day")
                                      .toDate(),
                                    startTime: formatDate(
                                      start,
                                      DateFormats.TimeOnlyFormat
                                    ),
                                    endTime: formatDate(
                                      end,
                                      DateFormats.TimeOnlyFormat
                                    ),
                                  },
                                };
                                setInitialData(activityModel);
                              }}
                            ></EditEventCalendarWraper>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="col-md col-12"></div>
                    </>
                  )}
                </>
              )}
            </div>
          ) : (
            <ContainerLoader></ContainerLoader>
          )}
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
      {customerModal?.isOpen && (
        <>
          <CustomerEdit
            onClose={() => setCustomerModal({})}
            id={customerModal?.id || ""}
            onReload={() => {
              getLead(leadState?.leadDetails?._id!);
              setCustomerModal({});
            }}
            entity={
              masterData?.data?.leadStages?.find(
                (x) => x.code === customerModal.entity
              )?.entity!
            }
            leadDetails={leadState.leadDetails}
          />
        </>
      )}
      {requirementModalOpen && (
        <Requirement
          leads={[leadState.leadDetails!]}
          customer={leadState.leadDetails?.customer}
          reload={() => {
            getLead(leadState?.leadDetails?._id!);
          }}
        ></Requirement>
      )}
    </ConfirmationDialogProvider>
  );
};

export default AddLeadForm;
